import React, { useEffect } from "react";
import ModernNavbar from "../components/modern-navbar";
import ModernFooter from "../components/modern-footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faMailBulk,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="modern-landing">
      <ModernNavbar />

      {/* Hero Section */}
      <section className="hero-modern contact-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                Let's Build Something
                <span className="gradient-text"> Amazing Together</span>
              </h1>
              <p className="hero-subtitle">
                Ready to transform your business? Get in touch with our team of
                experts and let's discuss how we can help you achieve your
                goals.
              </p>
            </div>
            <div className="hero-visual">
              <div className="dashboard-preview">
                <img
                  src="/assets/young-african-woman-with-curly-hair-talking-phone.jpg"
                  alt="Struts AI Dashboard"
                  className="hero-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2 className="section-title">Get In Touch</h2>
              <p className="contact-description">
                You can reach us at info@strutstechnology.com or by phone +254
                703 397527. Let's engage in a conversation and transform your
                ideas into reality.
              </p>

              <div className="contact-methods">
                <div className="contact-method">
                  <div className="method-icon">
                    <FontAwesomeIcon icon={faPhone} />
                  </div>
                  <div className="method-content">
                    <h4>Phone</h4>
                    <p>+254 703 397527</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-icon">
                    <FontAwesomeIcon icon={faEnvelope} />
                  </div>
                  <div className="method-content">
                    <h4>Email</h4>
                    <p>info@strutstechnology.com</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-icon">
                    <FontAwesomeIcon icon={faMailBulk} />
                  </div>
                  <div className="method-content">
                    <h4>Address</h4>
                    <p>P.O.Box 272-00208 Ngong Hills, Kenya</p>
                  </div>
                </div>
              </div>

              <div className="social-links">
                <h4>Follow Us</h4>
                <div className="social-grid">
                  <a
                    href="https://twitter.com/StrutsTech"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                  >
                    <FontAwesomeIcon icon={faTwitter} />
                    @StrutsTech
                  </a>
                  <a
                    href="https://twitter.com/StrutsAI"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                  >
                    <FontAwesomeIcon icon={faTwitter} />
                    @StrutsAI
                  </a>
                  <a
                    href="https://twitter.com/Kodi_Africa"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                  >
                    <FontAwesomeIcon icon={faTwitter} />
                    @Kodi_Africa
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-form-container">
              <div className="contact-form-card">
                <h3>Send us a message</h3>
                <form className="contact-form">
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input type="text" id="name" name="name" required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input type="email" id="email" name="email" required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="subject">Subject</label>
                    <input type="text" id="subject" name="subject" required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <textarea
                      id="message"
                      name="message"
                      rows="5"
                      required
                    ></textarea>
                  </div>
                  <button type="submit" className="btn-primary">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Info Section */}
      <section className="company-section">
        <div className="container">
          <div className="company-content">
            <h2>About Struts Technology</h2>
            <p>
              We are a leading software development company specializing in
              custom-made solutions that help businesses streamline their
              operations and achieve digital transformation.
            </p>
            <a
              href="https://www.strutstechnology.co.ke"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline"
            >
              Learn More About Us
            </a>
          </div>
        </div>
      </section>

      <ModernFooter />
    </div>
  );
};

export default Contact;
